import Auth from '../modules/Authentication'
import {apiUrl} from '../variables/index'
import {handleErrors, handleResponse} from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class Subsidiaries {
  constructor() {
    this.auth = new Auth()
  }

  create = member => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}subsidiaries/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(member),
    }).then(handleErrors)
  }
  list = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}subsidiaries/`, {headers})
      .then(handleErrors)
      .then(handleResponse)
  }
  get = key => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}subsidiaries/${key}`, {headers}).then(handleErrors)
  }
  getMember = key => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}subsidiaries/${key}/member`, {headers})
      .then(handleErrors)
      .then(handleResponse)
  }
  update = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}subsidiaries/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }
  permissions = {
    list: (key, org) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}subsidiaries/${key}/permissions/${org}`, {
        headers,
      }).then(handleErrors)
    },
    update: (key, org, data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}subsidiaries/${key}/permissions/${org}`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      }).then(handleErrors)
    },
  }
  banks = {
    list: key => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}subsidiaries/${key}/banks/`, {headers})
        .then(handleErrors)
        .then(handleResponse)
    },
    update: (key, bankID, data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}subsidiaries/${key}/banks/${bankID}`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
  }
  contracts = {
    list: key => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}subsidiaries/${key}/contracts/`, {headers})
        .then(handleErrors)
        .then(handleResponse)
    },
  }
  requisitions = {
    list: () => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}labourreqs/`, {headers})
        .then(handleErrors)
        .then(handleResponse)
    },
  }
  files = {
    list: key => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}subsidiaries/${key}/files/`, {headers})
        .then(handleErrors)
        .then(handleResponse)
    },
    update: (key, bankID, data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}subsidiaries/${key}/banks/${bankID}`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
  }
  entitlements = {
    get: key => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}subsidiaries/${key}/entitlements/`, {headers})
        .then(handleErrors)
        .then(handleResponse)
    },
  }
}
